/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GetThemesParams, ModelsTheme, ResponseThemeResponse, SetFocusedThemesPayload } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Themes<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Themes
   * @name CreateOrUpdateTheme
   * @summary Update the provided theme, currently used to make a theme focused or unfocused (Auth policies: ClientOrExpertPolicy)
   * @request PUT:/api/v1/themes/user-themes/{themeKey}
   * @secure
   * @response `200` `ModelsTheme` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  createOrUpdateTheme = (themeKey: string, data: ModelsTheme, params: RequestParams = {}) =>
    this.http.request<ModelsTheme, void>({
      path: `/api/v1/themes/user-themes/${themeKey}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Themes
   * @name GetThemes
   * @summary Gets the details of all available themes
   * @request GET:/api/v1/themes
   * @secure
   * @response `200` `(ResponseThemeResponse)[]` OK
   */
  getThemes = (query: GetThemesParams, params: RequestParams = {}) =>
    this.http.request<ResponseThemeResponse[], any>({
      path: `/api/v1/themes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Themes
   * @name GetUserMedicalThemes
   * @summary Gets all the theme details for the selected user (Auth policies: ClientOrExpertPolicy)
   * @request GET:/api/v1/themes/user-themes/medical
   * @secure
   * @response `200` `(ModelsTheme)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserMedicalThemes = (params: RequestParams = {}) =>
    this.http.request<ModelsTheme[], void>({
      path: `/api/v1/themes/user-themes/medical`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Themes
   * @name GetUserThemeCheckins
   * @summary The the user checkins for this theme. (Auth policies: ClientOrExpertPolicy)
   * @request GET:/api/v1/themes/user-themes/{themeKey}
   * @secure
   * @response `200` `ModelsTheme` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserThemeCheckins = (themeKey: string, params: RequestParams = {}) =>
    this.http.request<ModelsTheme, void>({
      path: `/api/v1/themes/user-themes/${themeKey}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Themes
   * @name GetUserThemes
   * @summary Gets all the theme details for the selected user (Auth policies: ClientOrExpertPolicy)
   * @request GET:/api/v1/themes/user-themes
   * @secure
   * @response `200` `(ModelsTheme)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserThemes = (params: RequestParams = {}) =>
    this.http.request<ModelsTheme[], void>({
      path: `/api/v1/themes/user-themes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Themes
   * @name SetFocusedThemes
   * @summary Update the provided theme, currently used to make a theme focused or unfocused (Auth policies: ClientOrExpertPolicy)
   * @request POST:/api/v1/themes/focused-themes
   * @secure
   * @response `200` `(ModelsTheme)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setFocusedThemes = (data: SetFocusedThemesPayload, params: RequestParams = {}) =>
    this.http.request<ModelsTheme[], void>({
      path: `/api/v1/themes/focused-themes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
